import React, { useCallback, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { chileCurrency } from 'shared/utils';
import { ModalHelper } from "shared/modal";
import { Checkbox } from "components";
import { useOffers } from "hooks/useOffers";
import TermAndConditionsContent
    from "components/style-guide/modal/components/TermAndConditions/TermAndConditionsContent";
import { SectionItem } from './section-item';

import userImg from 'assets/images/icons/user.png';
import carImg from 'assets/images/icons/vehiculo.png';
import moneyImg from 'assets/images/icons/money.png';
import billImg from 'assets/images/icons/bill.png';
import styles from './Resume.module.scss';
import { registerAnalyticsEvent } from 'shared/utils/analytics';
import { Google_Analitys_Categories } from 'settings/data';

export const Resume = props => {
    const { price } = useOffers();
    const { ga_actions, cat_new_report } = Google_Analitys_Categories;
    const {
        data: { billInfo, paymentType, generalData },
        acceptTermAndConditionsAction,
        acceptTermAndConditions = false
    } = props;

    const boxStyle = styles.boxContainer + " d-flex flex-fill flex-wrap p-3";

    useEffect(() => {        
        registerAnalyticsEvent({ category: cat_new_report, action: ga_actions.load, label: 'init_summary_step' });
    }, [])


    const openTermAndConditions = useCallback(() => {
        ModalHelper.open("TÉRMINOS Y CONDICIONES", <TermAndConditionsContent />)
    }, []);

    return (
        <>
            <div className="d-flex flex-wrap flex-fill py-3 overflow-y-auto">
                {/* Datos Vehiculares */}
                <div className={boxStyle}>
                    <div className="pr-3">
                        <span className={clsx("badge badge-light p-3", styles.sectionIcon)}>
                            <img src={carImg} alt="user session car-icon" />
                        </span>
                    </div>
                    <div className="d-flex flex-column " style={{ height: generalData.patentes.length > 7 ? "300px" : "100%", width: "190px" }}>
                        <h5 className="title text-nowrap">DATOS VEHICULARES</h5>
                        <span className="gray-300">{generalData.patentes.length > 1 ? 'Patentes' : 'Patente'}</span>
                        <span className="list-box overflow-y-auto" style={{ height: generalData.patentes.length > 7 ? "100%" : (generalData.patentes.length * 35) + 'px' }}>
                            {generalData.patentes.map(v => <p className="font-weight-bold m-1" key={v.patente}> {v.patente} </p>)}
                        </span>
                    </div>
                </div>
                {/* Datos Personales */}
                <div className={boxStyle}>
                    <div className="pr-3">
                        <span className={clsx("badge badge-light p-3", styles.sectionIcon)}>
                            <img src={userImg} alt="user session user-icon" />
                        </span>
                    </div>
                    <div className="d-flex flex-column flex-fill">
                        <h5 className="title text-nowrap">DATOS PERSONALES</h5>
                        <SectionItem label="RUT" value={generalData.rut} />
                        <SectionItem label="Nombre y Apellidos" value={generalData.name} />
                        <SectionItem label="Correo Electrónico" value={generalData.email} />
                        <SectionItem label="Teléfono" value={generalData.phone ? `+${generalData.phone}` : '-'} />
                    </div>
                </div>
                {/* Datos de Facturación */}
                {
                    billInfo.rut &&
                    <div className={boxStyle}>
                        <div className="pr-3">
                            <span className={clsx("badge badge-light p-3", styles.sectionIcon)}>
                                <img src={billImg} alt="user session bill-icon" />
                            </span>
                        </div>
                        <div className="d-flex flex-column flex-fill">
                            <h5 className="title text-nowrap">RUT</h5>
                            <SectionItem label="RUT" value={billInfo.rut} />
                            <SectionItem label="Razón Social" value={billInfo.businessType} />
                            <SectionItem label="Actividad Económica" value={billInfo.economicActivity} />
                            <SectionItem label="Dirección" value={billInfo.address} />
                        </div>
                    </div>
                }
                {/* Datos del Pago */}
                <div className={boxStyle}>
                    <div className="pr-3">
                        <span className={clsx("badge badge-light p-3", styles.sectionIcon)}>
                            <img src={moneyImg} alt="user session money-icon " />
                        </span>
                    </div>
                    <div className="d-flex flex-column flex-fill">
                        <h5 className="title text-nowrap">Datos del pago</h5>
                        <SectionItem label="Forma de Pago" value={paymentType} />
                        <SectionItem label="Total Reportes" value={generalData.patentes.reduce((total, patent) => total + patent.reportType.length, 0)} />
                        <SectionItem label="Recibir Factura" value={billInfo.rut ? 'Sí' : 'No'} />
                        <SectionItem label="Precio Unitario" value={chileCurrency(price)} />
                        <SectionItem label="Monto Total" value={chileCurrency(generalData.patentes.length * price)} />
                    </div>
                </div>
            </div>

            <div className={clsx('p-3 m-0 flex')}>
                <Checkbox
                    className={styles.termAndConditionContainer}
                    value={true}
                    checked={acceptTermAndConditions}
                    onChange={(v) => acceptTermAndConditionsAction(v.target.checked)} />

                <p className={styles.termAndCondition}>Debe marcar los
                    <span role="button" tabIndex={-1}
                        onClick={openTermAndConditions}> Términos y Condiciones </span> para poder efectuar el pago.
                </p>
            </div>
        </>
    );
};

Resume.propTypes = {
    data: PropTypes.object,
};

Resume.defaultProps = {
    data: {
        billInfo: {},
        paymentType: "",
    }
}

export default Resume;
